export enum InvoiceView {
  SUMMARY = 'Summary',
  RECONCILIATION = 'Recon',
  LUMPSUM = 'LumpSum',
}
